<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
    style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='出科管理' label2='延期人员出科审核' url='/cycle/out/outcheckmanage'></PageHead>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.secretarysec" filterable placeholder="全部" @change="ManageSecChange">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName"
                    :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">轮转科室：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.section" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in secOptions" :key="item.DictItemID" :label="item.DictItemName"
                    :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <SearchNormalText v-model='condition.truename' label='姓名'></SearchNormalText>
          <SearchNormalText v-model='condition.cardno' label='工号'></SearchNormalText>
          <ZPGLSearchDictItemSelect v-model='condition.specialty' label='专业' :dictid='this.$utils.DictEnum.specialty'>
          </ZPGLSearchDictItemSelect>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">出科时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.outdate" type="month" placeholder="出科时间" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column>
              <template slot="header">
                姓名<br>工号
              </template>
              <template slot-scope="scope">
                {{scope.row.CPStuName}}<br>{{scope.row.CPStuNo}}
              </template>
            </el-table-column>
            <el-table-column>
              <template slot="header">
                专业<br>用户类型
              </template>
              <template slot-scope="scope">
                {{scope.row.StuSpecName}}<br>{{scope.row.StuUserTypeName}}
              </template>
            </el-table-column>
            <el-table-column prop="CPManageSecName" label="管理单元">
            </el-table-column>
            <el-table-column prop="CPSecName" label="轮转科室">
            </el-table-column>
            <el-table-column label="轮转时间" width="240">
              <template slot-scope="scope">
                {{scope.row.CPBeginDate|formatFullDate}} 至 {{scope.row.CPEndDate|formatFullDate}}
              </template>
            </el-table-column>
            <el-table-column label="考核时间" width="240">
              <template slot-scope="scope">
                {{scope.row.ExamDate|formatFullDate}} <br> {{scope.row.ExamTimeName}}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button type="text" size="medium" @click="ScoreInfo(scope.row)">审核</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="condition.currentPage" :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog width="30%" title="出科申请审核" :visible.sync="socreInfoVisible">
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="infoform">
        <el-row>
          <el-col :span="24">
            <el-form-item label="姓名:">
              {{infoform.CPStuName}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="轮转科室:">
              {{infoform.CPSecName}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="轮转时间:">
              {{infoform.CPDate}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="考官1:">
              {{infoform.TecName1}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="考官2:">
              {{infoform.TecName2}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="考官3:">
              {{infoform.TecName3}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="预约时间:">
              {{infoform.OutApplyDate}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="考核科目:">
              {{infoform.projectname}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="审核意见:">
              <el-input v-model="infoform.checkinfo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="">
        <el-button type="success" @click="Check(2)" v-loading.fullscreen.lock="fullscreenLoading">通 过</el-button>
        <el-button type="danger" @click="Check(3)" v-loading.fullscreen.lock="fullscreenLoading">不通过</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  export default {
    name: 'DelayOutApplyCheckManage',
    data() {
      return {
        condition: {
          token: '',
          username: '',
          rolelevel: '',
          secretarysec: '',
          section: '',
          truename: '',
          cardno: '',
          specialty: '',
          outdate: '',
          examtype: '',
          outstatus: '1',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true,
        },
        searchUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/DelayOutApplyList',
        managesecOptions: [],
        secOptions: [],
        oaStatusOptions: [{
            value: '0',
            label: '未申请'
          }, {
            value: '1',
            label: '未审核'
          },
          {
            value: '2',
            label: '审核通过'
          },
          {
            value: '3',
            label: '审核不通过'
          }
        ],
        tableData: [],
        loading: true,
        fullscreenLoading: false,
        infoform: {
          token: '',
          cpid: '',
          CPStuName: '',
          CPSecName: '',
          CPDate: '',
          TecID1: '',
          TecID2: '',
          TecID3: '',
          TecName1: '',
          TecName2: '',
          TecName3: '',
          OutApplyDate: '',
          checkinfo: '',
          checkstatus: '',
          ExamTypeName: '',
          ExamType: '',
          DelayReason: '',
          oaid: ''
        },
        socreInfoVisible: false
      }
    },
    filters: {
      formatDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        return y + '-' + (m < 10 ? '0' + m : m)
      },
      formatFullDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        var d = now.getDate()
        return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
      }
    },
    methods: {
      ScoreInfo: function(row) {
        var args = {
          token: this.condition.token,
          oaid: row.OAID,
          oatype: 1
        }

        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/LoadOutApplyScore', args, function(data) {
          var info = data.Data
          that.infoform.oaid = info.OAID
          that.infoform.CPStuName = info.CPStuName
          that.infoform.CPSecName = info.CPSecName
          that.infoform.ExamTypeName = info.ExamTypeName
          that.infoform.ExamType = info.ExamType
          that.infoform.DelayReason = info.DelayReason

          var date = new Date(info.CPBeginDate)
          var y = date.getFullYear()
          var m = date.getMonth() + 1
          var d = date.getDate()
          var begindate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d)

          date = new Date(info.CPEndDate)
          y = date.getFullYear()
          m = date.getMonth() + 1
          d = date.getDate()
          var enddate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d)

          that.infoform.CPDate = begindate + ' - ' + enddate

          date = new Date(info.ExamDate)
          y = date.getFullYear()
          m = date.getMonth() + 1
          d = date.getDate()

          that.infoform.OutApplyDate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d) +
            ' ' + info.ExamTimeName

          that.infoform.projectname = info.ProjectName

          that.LoadOutApplyScoreTecInfo(that.infoform.oaid)
        }, null, null, null)

      },
      LoadOutApplyScoreTecInfo: function(OAID) {
        var args = {
          token: this.condition.token,
          oaid: OAID
        }

        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/OutApplyTecInfo', args, function(data) {
          var list = data.Data
          for (var i = 0; i < list.length; i++) {
            if (i == 0) {
              that.infoform.TecName1 = list[i].TecName + '(' + list[i].TecNo + ')'
            } else if (i == 1) {
              that.infoform.TecName2 = list[i].TecName + '(' + list[i].TecNo + ')'
            } else if (i == 2) {
              that.infoform.TecName3 = list[i].TecName + '(' + list[i].TecNo + ')'
            }
          }
          that.socreInfoVisible = true
        }, null, null, null)
      },
      Check: function(status) {
        var checkmessage = ''
        if (status == 2) {
          checkmessage = '审核通过'
        } else {
          checkmessage = '审核不通过'
        }

        this.$confirm('确定' + checkmessage + '该出科申请?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.fullscreenLoading = true
          this.infoform.checkstatus = status
          var that = this
          this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/CheckOutApply', this.infoform)
            .then(res => {
              console.log(res.data)
              if (res.data.Code === 0) {
                that.$message({
                  message: '审核成功',
                  type: 'success'
                })
                that.socreInfoVisible = false
                that.$refs.btnSearch.Search()
              } else {
                that.$message({
                  message: res.data.Msg + '，' + res.data.Error,
                  type: 'error'
                })
              }
              that.fullscreenLoading = false
            })
            .catch(err => {
              console.log(err)
              that.$message({
                message: '审核失败',
                type: 'error'
              })
              that.fullscreenLoading = false
            })
        }).catch(() => {})
      },
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      LoadManageSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
          that.$refs.btnSearch.Search()
        }, null, null, null)
      },
      ManageSecChange: function() {
        this.condition.section = ''
        this.secOptions = []
        this.LoadCPSec()
      },
      LoadCPSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel,
          mamagesec: this.condition.secretarysec
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function(data) {
          that.secOptions = data.Data
        }, null, null, null)
      },
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.infoform.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')

      this.LoadManageSec()
    }
  }
</script>

<style scoped="scoped">
  .message-box {
    width: 600px;
  }

  .timeclass {
    width: 100%;
  }

  /deep/.el-table .cell {
    line-height: 25px;
  }

  /deep/.el-input {
    width: 220px;
  }

  .el-form-item {
    margin-bottom: 5px;
  }

  /deep/.el-radio {
    margin-bottom: 0;
  }
</style>
